import { render, staticRenderFns } from "./TypeControlDetailTable.vue?vue&type=template&id=42eb1d12"
import script from "./TypeControlDetailTable.vue?vue&type=script&lang=js"
export * from "./TypeControlDetailTable.vue?vue&type=script&lang=js"
import style0 from "./TypeControlDetailTable.vue?vue&type=style&index=0&id=42eb1d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports